const _BASE_API_URL = process.env.REACT_APP_API_URL
const API_URL = _BASE_API_URL + '/v1'

export const FILE_SHARING_URL = API_URL
